const invalidVarSyntax = line => {
  const msg = `the variable declaration is invalid, make sure that you are using valid syntax thx...`;
  return `${msg} ${printFormattedError(line, line.content)}`;
};

const invalidEqualSign = line => {
  const msg = `you can not assign a vlue to a variable using an equal sign, replace it with a ":" thx...`;
  return `${msg} ${printFormattedError(line, line.content)}`;
};

function printFormattedError(line, target) {
  line = { ...line };
  line.content = line.content.trim();
  line.prevLine = line.prevLine ? line.prevLine.trim() : "";
  const prevPos = lineNumber(line.position);
  const pos = lineNumber(line.position + 1, true);
  return `\n
        ${line.prevLine ? `${prevPos} ${line.prevLine}` : ""}

        ${pos} ${line.content}
        ${printErrorHighlight(line.content, target)}
    `;
}

function printErrorHighlight(line, target) {
  const targetIndex = line.indexOf(target);
  return (
    "     " +
    Array.from(line)
      .map((i, idx) => (idx >= targetIndex && idx < target.length - 1 + targetIndex ? "^" : " "))
      .join("")
  );
}

function lineNumber(pos, target = false) {
  const posStr = Array.from(String(pos));
  let finalStr = "";
  for (let idx = 1; idx < 5; idx++) {
    if (target && idx == 1) {
      finalStr += ">";
    } else if (posStr.length >= 5 - idx) {
      finalStr += posStr.shift();
    } else {
      finalStr += " ";
    }
  }
  return `${finalStr} |`;
}

export default {
  invalidVarSyntax,
  invalidEqualSign
};
